/**
 * Extrae el mensaje de error de una respuesta de API
 */
export const getErrorMessage = (error) => {
  if (error?.response?.data?.error?.message) {
    return error.response.data.error.message;
  }

  if (error?.response?.data?.message) {
    return error.response.data.message;
  }

  if (error?.message) {
    return error.message;
  }

  return 'Ocurrió un error inesperado al iniciar sesión';
};

/**
 * Guarda la sucursal seleccionada en localStorage
 */
export const saveBranchToStorage = (branch) => {
  if (!branch) return;

  try {
    localStorage.setItem('selected-branch', JSON.stringify(branch));
  } catch (error) {
    console.error('Error al guardar la sucursal:', error);
  }
};

/**
 * Obtiene la sucursal guardada de localStorage
 */
export const getSavedBranch = () => {
  try {
    const saved = localStorage.getItem('selected-branch');
    return saved ? JSON.parse(saved) : null;
  } catch (error) {
    console.error('Error al obtener la sucursal guardada:', error);
    return null;
  }
};

/**
 * Limpia la sucursal de localStorage
 */
export const clearSavedBranch = () => {
  try {
    localStorage.removeItem('selected-branch');
  } catch (error) {
    console.error('Error al limpiar la sucursal:', error);
  }
};
